import { Typography } from '@pvh-components/typography';
import styles from './qrCodePopup.module.css';

interface QRCodeHeaderProps {
  popupHeading: string;
  popupText: string;
}

const QRCodeHeader = ({ popupHeading, popupText }: QRCodeHeaderProps) => {
  return (
    <div className={styles.qrCodeContent}>
      <Typography variant="h3">{popupHeading}</Typography>
      <Typography variant="bodyMedium">{popupText}</Typography>
    </div>
  );
};

export default QRCodeHeader;
